import { css } from '@emotion/css';
import { colors } from '@editor2/styles/colors';

export const iconButton = css`
	border: 0;
	background-color: transparent;

	:disabled {
		pointer-events: none;
	}

	svg {
		:hover {
			cursor: pointer;
			color: ${colors.hoverText};
		}
	}
`;
